// assets
import { IconBuildingBank } from '@tabler/icons';

// constant
const icons = {
    IconBuildingBank,
};

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const universityPages = {
    id: 'University management',
    title: 'University management',
    caption: 'manage universitiy list',
    type: 'group',
    children: [
        {
            id: 'fetchUniversity',
            title: 'University',
            type: 'item',
            url: '/universities/View',
            icon:icons.IconBuildingBank
        }
    ],

};

export default universityPages;
